export default function pmLocalization(obj) {
  return {
    tooltips: {
      placeMarker: `${obj.$i18n.t('pm_place_marker')}`,
      firstVertex: `${obj.$i18n.t('pm_first_vertex')}`,
      continueLine: `${obj.$i18n.t('pm_continue_line')}`,
      finishLine: `${obj.$i18n.t('pm_finish_line')}`,
      finishPoly: `${obj.$i18n.t('pm_finish_poly')}`,
      finishRect: `${obj.$i18n.t('pm_finish_rect')}`,
      startCircle: `${obj.$i18n.t('pm_start_circle')}`,
      finishCircle: `${obj.$i18n.t('pm_finish_circle')}`,
      placeCircleMarker: `${obj.$i18n.t('pm_place_circle_marker')}`,
    },
    actions: {
      finish: `${obj.$i18n.t('pm_finish')}`,
      cancel: `${obj.$i18n.t('pm_cancel')}`,
      removeLastVertex: `${obj.$i18n.t('pm_remove_last_vertex')}`,
    },
    buttonTitles: {
      drawMarkerButton: `${obj.$i18n.t('pm_draw_marker_button')}`,
      drawPolyButton: `${obj.$i18n.t('pm_draw_poly_button')}`,
      drawLineButton: `${obj.$i18n.t('pm_draw_line_button')}`,
      drawCircleButton: `${obj.$i18n.t('pm_draw_circle_button')}`,
      drawRectButton: `${obj.$i18n.t('pm_draw_rect_button')}`,
      editButton: `${obj.$i18n.t('pm_edit_button')}`,
      dragButton: `${obj.$i18n.t('pm_drag_button')}`,
      cutButton: `${obj.$i18n.t('pm_cut_button')}`,
      deleteButton: `${obj.$i18n.t('pm_delete_button')}`,
      drawCircleMarkerButton: `${obj.$i18n.t('pm_draw_circle_marker_button')}`,
    },
  }
}
